export default "__VITE_ASSET__Dm61tdFq__"